import { useNuxtApp } from "#app"
import { storeToRefs } from "pinia"

export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()

	const { $apiHelper, $termsApiService, $eventBus } = useNuxtApp()

	const termsStore = useTermsStore()
	const { email, signature, signedAt } = storeToRefs(termsStore)

	nuxtApp.provide("termsService", {
		$storeTerms: async () => {
			$apiHelper.$showLoader()
			const aws_event_id = runtimeConfig.public.EVENT_ID

			const { data, pending, status } = await $termsApiService.$storeTerms(email, aws_event_id, signature, signedAt)

			$apiHelper.$handleResponse(pending, status, data, (response) => {
				console.log("stored terms")
				console.log(response)
			})
		},
	})
})
